var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMina(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 38,
    viewBox: "0 0 98 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_65_833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 4.00017C18.2081 3.99432 17.4228 4.13789 16.6903 4.42247C15.9578 4.70705 15.2927 5.12693 14.734 5.65751C14.1753 6.18809 13.7342 6.81871 13.4365 7.51245C13.1389 8.20618 12.9906 8.94908 13.0005 9.69765C13.0005 12.8883 16.295 17.1031 19 22C21.705 17.1039 24.9995 12.8883 24.9995 9.69765C25.0094 8.94908 24.8611 8.20618 24.5635 7.51245C24.2658 6.81871 23.8247 6.18809 23.266 5.65751C22.7073 5.12693 22.0422 4.70705 21.3097 4.42247C20.5772 4.13789 19.7919 3.99432 19 4.00017ZM19 12.1371C18.4841 12.1371 17.9798 11.9925 17.5508 11.7215C17.1218 11.4506 16.7875 11.0655 16.5901 10.6149C16.3926 10.1644 16.341 9.66862 16.4416 9.19031C16.5423 8.71201 16.7907 8.27266 17.1555 7.92782C17.5203 7.58298 17.9851 7.34814 18.4911 7.253C18.9971 7.15786 19.5216 7.20669 19.9982 7.39331C20.4749 7.57994 20.8823 7.89598 21.1689 8.30146C21.4555 8.70695 21.6085 9.18368 21.6085 9.67135C21.6085 10.3253 21.3337 10.9525 20.8445 11.4149C20.3553 11.8773 19.6918 12.1371 19 12.1371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2505 9.69765L13.2504 9.69436C13.241 8.98109 13.3823 8.27287 13.6663 7.61103C13.9503 6.94914 14.3715 6.34649 14.9062 5.83879C15.4408 5.33105 16.078 4.92855 16.7808 4.6555C17.4837 4.38245 18.2375 4.24454 18.9982 4.25019L19.0018 4.25017C19.7625 4.24454 20.5163 4.38245 21.2192 4.6555C21.922 4.92855 22.5592 5.33105 23.0938 5.83879C23.6285 6.34649 24.0497 6.94914 24.3337 7.61103C24.6177 8.27287 24.759 8.98109 24.7496 9.69436H24.7495V9.69765C24.7495 11.2205 23.959 13.0202 22.7963 15.0867C22.2713 16.0196 21.6768 16.9967 21.0553 18.0181C20.9921 18.122 20.9287 18.2263 20.865 18.331C20.2494 19.3435 19.6128 20.3973 19 21.4866C18.3872 20.3971 17.7506 19.3432 17.135 18.3307C17.0709 18.2252 17.007 18.1201 16.9433 18.0155C16.3223 16.9949 15.7283 16.0186 15.2037 15.0864C14.041 13.02 13.2505 11.2205 13.2505 9.69765ZM17.4173 11.9329C17.8869 12.2295 18.4377 12.3871 19 12.3871C19.7537 12.3871 20.4792 12.1042 21.0162 11.5966C21.5537 11.0885 21.8585 10.3963 21.8585 9.67135C21.8585 9.13099 21.6889 8.60403 21.373 8.15716C21.0573 7.71048 20.61 7.36438 20.0894 7.16052C19.5688 6.95669 18.9967 6.90355 18.4449 7.0073C17.8931 7.11106 17.3844 7.36748 16.9838 7.74614C16.5831 8.12494 16.3084 8.6093 16.197 9.13883C16.0855 9.66849 16.1429 10.2173 16.3611 10.7153C16.5792 11.213 16.9475 11.6362 17.4173 11.9329Z",
    stroke: "#E9E9E9",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 4,
    width: 48,
    height: 18,
    rx: 4,
    fill: "#7789A3",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.828 9.432H45.48L47.484 15.324H47.508L49.404 9.432H52.056V18H50.292V11.928H50.268L48.168 18H46.716L44.616 11.988H44.592V18H42.828V9.432ZM53.7147 9.432H55.5987V18H53.7147V9.432ZM57.2538 9.432H59.1258L62.7018 15.18H62.7258V9.432H64.4898V18H62.6058L59.0418 12.264H59.0178V18H57.2538V9.432ZM68.3083 14.688H70.5283L69.4483 11.544H69.4243L68.3083 14.688ZM68.4883 9.432H70.4203L73.6243 18H71.6683L71.0203 16.092H67.8163L67.1443 18H65.2483L68.4883 9.432Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_65_833",
    x: 0,
    y: 0,
    width: 98,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.45 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_65_833"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_65_833",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMina);
export default __webpack_public_path__ + "static/media/Mina.194f9db40c957b4f2a8ce14da1796f50.svg";
export { ForwardRef as ReactComponent };